import { Modal } from 'antd';

import useModal from '~/common/hooks/useModal.ts';

import type { ModalProps } from 'antd';

import type { ModalName } from '~/common/types/modal.type.ts';

export interface BaseModalProps extends ModalProps {
  name: ModalName;
}

function BaseModal({
  name,
  children,
  title,
  closable = false,
  maskClosable = false,
  width,
  onCancel,
  ...props
}: BaseModalProps) {
  const { isOpened, close } = useModal(name);

  return (
    <Modal
      title={
        title
        // <header>
        //   {title}
        //   <Divider css={styles.divider} />
        // </header>
      }
      closable={closable}
      // css={styles.baseModal}
      // footer={null}
      getContainer={() => document.getElementById('__modal__') || document.body}
      maskClosable={maskClosable}
      open={isOpened()}
      width={width}
      destroyOnClose
      {...props}
      onCancel={e => {
        close();
        onCancel?.(e);
      }}
    >
      {children}
    </Modal>
  );
}

// const styles = {
//   baseModal: css`
//     .ant-modal-content {
//       border-radius: 8px;
//       border: 1px solid ${COLORS.GRAY['400']};
//       background-color: ${COLORS.GRAY['50']};
//       box-shadow: 0 8px 8px 0 rgba(26, 27, 29, 0.08);

//       padding: ${SPACING['5']} ${SPACING['6']};
//     }
//   `,

//   divider: css`
//     margin-top: ${SPACING['4']};
//     margin-bottom: ${SPACING['7']};
//   `,
// };

export default BaseModal;
